import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from "react";
import MaskedInput from "./MaskedInput";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Controller } from "react-hook-form";
const styles = {
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    margin: "0 10px"
  },
  textField: {
    // flexBasis: 200,
  },
  hidden: {
    width: 0,
    height: 0,
    display: "none"
  },
  truncate: {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  hide: {
    display: "none"
  }
};
class TextFieldMaskHook extends Component {
  constructor() {
    super(...arguments);
    this.reachedMax = (this.props.value && this.props.value.length) === this.props.maxLength;
    this.textMaskCustom = props => {
      const inputRef = props.inputRef,
        other = _objectWithoutProperties(props, ["inputRef"]);
      return /*#__PURE__*/React.createElement(MaskedInput, Object.assign({}, other, {
        getInputRef: inputRef,
        mask: this.props.mask,
        defaultValue: other.value,
        type: "text"
      }));
    };
  }
  getRenderedComponent() {
    return this.ref.current;
  }
  getClasses() {
    const classes = this.props.classes; // const statusClass = editStatus ? classes.edit : classes.disabled;
    // const hiddenClass = hidden ? classes.hidden : classes.none;
    if (this.props.showMargin === "none") {
      return "".concat(classes.textField, " ");
    } else {
      return "".concat(classes.textField, " ").concat(classes.margin, " ");
    }
  }
  render() {
    const _this$props = this.props,
      input = _this$props.input,
      required = _this$props.required,
      meta = _this$props.meta,
      disabled = _this$props.disabled,
      className = _this$props.className,
      custom = _objectWithoutProperties(_this$props, ["input", "required", "meta", "disabled", "className"]); //let { submitFailed, error } = meta;
    const classes = this.props.classes; //let hasError = submitFailed && error;
    // if (!hasError && required && meta && meta.touched && input.value === "") {
    // 	hasError = true;
    // 	error = "* Required";
    // }
    let hasError = false;
    console.log(this.props);
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement(Controller, {
      as: /*#__PURE__*/React.createElement(TextField, {
        className: "".concat(className ? className : this.getClasses(), " ").concat(disabled ? classes.hide : ""),
        helperText: hasError ? error : " ",
        key: custom.key,
        required: required,
        validation: custom.validation,
        variant: custom.variant,
        label: custom.label,
        placeholder: custom.placeholder,
        onKeyUp: custom.onKeyUp,
        error: hasError
        //defaultValue={input.value}
        ,
        autoFocus: custom.autoFocus ? true : false,
        multiline: custom.multiLine ? true : false
        //id={input.name + "-input"}
        ,
        fullWidth: custom.fullWidth,
        margin: custom.margin,
        InputLabelProps: custom.InputLabelProps ? custom.InputLabelProps : {
          shrink: custom.labelShrink
        },
        InputProps: {
          inputComponent: this.textMaskCustom,
          disableUnderline: custom.disableUnderline ? true : false,
          maxLength: custom.maxLength,
          disabled: disabled
        }
      }),
      control: this.props.control,
      name: this.props.name
    }));
  }
}
export default withStyles(styles)(TextFieldMaskHook);